<template>
  <body>
    <div id="aria-label_locator">
      <Header title="Data Visualizer" subtitle="" />
    </div>
    <main role="main" class="container mt-5 mx-auto">
      <div class="d-desktop-flex w-100 mb-5 px-3 px-desktop-0">
        <div
          class="
            search-container
            d-tablet-flex d-desktop-block
            p-2
            mx-auto
            mr-desktop-5
            ml-desktop-0
            mb-5 mb-desktop-0
          "
        >
          <div
            class="
              results-container
              flex-tablet-grow-1
              mt-5 mt-tablet-0 mt-desktop-5
              px-3 px-tablet-5 px-desktop-2
            "
          >
            <p
              class="is-size-5 font-family-robo p-3"
              aria-live="polite"
              id="aria-live_error"
              v-if="
                search.isActive && !search.hasResults && !this.street.length
              "
            >
              <i class="far fa-times-circle has-text-danger">
                That address is outside our district.</i
              >
              Please visit
              <a
                class="has-text-weight-semibold"
                href="http://www.mpsaz.org/parents/open_enroll"
                >our open enrollment page.</a
              >
            </p>
            <div
              v-else-if="search.isActive && search.hasResults"
              aria-hidden="true"
            >
              <div
                class="d-flex align-items-center py-3"
                style="border-bottom: 1px solid black"
              >
                <img
                  src="/images/icons/gmaps/marker-home.png"
                  alt="Google Maps Marker"
                />
                <p class="pl-3">{{ search.userGeocodeResults.address }}</p>
              </div>
              <ul class="py-3" aria-hidden="true">
                <li
                  v-for="school in search.homeschools"
                  :key="school.id"
                  class="d-flex align-items-center py-2"
                >
                  <img
                    :src="`/images/icons/gmaps/${school.gmaps_marker}`"
                    alt="Google Maps Marker"
                  />
                  <p
                    class="px-3 hover-cursor-pointer flex-grow-1"
                    @click="toggleHomeSchoolPolygon($event, school)"
                  >
                    {{ `${school.name} ${school.end_name}` }}
                  </p>
                  <input
                    :id="`${school.name} boundaries`"
                    name="checkbox"
                    type="checkbox"
                    class="hover-cursor-pointer"
                    @change="toggleHomeSchoolPolygon($event, school)"
                  />
                  <label
                    class="mx-2"
                    aria-label="checkbox"
                    :for="`#${school.name} boundaries`"
                  ></label>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="
              !this.street.length && !this.zipcode.length && !search.hasResults
            "
            class=""
          >
            <fieldset>
              <legend
                class="
                  text-center
                  font-family-montserrat
                  is-size-4
                  mx-desktop-0
                  pb-2
                  mb-3
                "
              >
                Filters
              </legend>
              <h4
                class="ul-title"
                v-on:click="toggleAccordion('elems')"
                role="button"
              >
                Elementary
                <span
                  id="elemToggle"
                  :class="
                    !this.elems
                      ? 'fas fa-toggle-off fa-pull-right fa-fw text-white'
                      : 'fas fa-toggle-on fa-pull-right fa-fw text-white'
                  "
                ></span>
              </h4>
              <ul id="elems" :class="this.elems ? 'ul-body' : 'ul-hide'">
                <li
                  class="ml-2"
                  v-bind:key="school.id"
                  v-for="school in schools.elementary"
                  v-on:click="toggleZoomSchool(school, 'elems')"
                >
                  <a>{{ school.name }}</a>
                </li>
              </ul>
              <h4
                class="ul-title"
                v-on:click="toggleAccordion('jh')"
                role="button"
              >
                Junior High
                <span
                  id="jhToggle"
                  :class="
                    !this.jrHighs
                      ? 'fas fa-toggle-off fa-pull-right fa-fw text-white'
                      : 'fas fa-toggle-on fa-pull-right fa-fw text-white'
                  "
                ></span>
              </h4>
              <ul
                id="jh"
                :class="this.jrHighs ? 'ul-body' : 'ul-hide'"
                ref="jh"
              >
                <li
                  class="ml-2"
                  v-on:click="toggleZoomSchool(school, 'juniorHighs')"
                  v-bind:key="school.id"
                  v-for="school in schools.junior_high"
                >
                  <a>{{ school.name }}</a>
                </li>
              </ul>
              <h4
                class="ul-title"
                v-on:click="toggleAccordion('hs')"
                role="button"
              >
                Senior High
                <span
                  id="hsToggle"
                  :class="
                    !this.highSchools
                      ? 'fas fa-toggle-off fa-pull-right fa-fw text-white'
                      : 'fas fa-toggle-on fa-pull-right fa-fw text-white'
                  "
                ></span>
              </h4>
              <ul
                id="hs"
                :class="this.highSchools ? 'ul-body' : 'ul-hide'"
                ref="hs"
              >
                <li
                  class="ml-2"
                  v-on:click="toggleZoomSchool(school, 'highSchools')"
                  v-bind:key="school.id"
                  v-for="school in schools.high_school"
                >
                  <a>{{ school.name }}</a>
                </li>
              </ul>
              <h4
                class="ul-title"
                v-on:click="toggleAccordion('choice')"
                role="button"
              >
                Choice
                <span
                  id="choiceToggle"
                  :class="
                    !this.choice
                      ? 'fas fa-toggle-off fa-pull-right fa-fw text-white'
                      : 'fas fa-toggle-on fa-pull-right fa-fw text-white'
                  "
                ></span>
              </h4>
              <ul
                id="choice"
                :class="this.choice ? 'ul-body' : 'ul-hide'"
                ref="hs"
              >
                <li
                  class="ml-2"
                  v-on:click="toggleZoomSchool(school, 'choice')"
                  v-bind:key="school.id"
                  v-for="school in schools.choice"
                >
                  <a>{{ school.name }}</a>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>
        <!-- end search-area -->

        <!-- <transition name="fade"> -->
        <div class="map-container w-100" role="group" aria-label="google map">
          <gmap-map class="w-100 h-100" :center="mapCenter" :zoom="zoom">
            <div
              id="elemMap"
              v-if="this.elems && !this.street.length && !this.zipcode.length"
            >
              <gmap-marker
                v-for="school in schools.elementary"
                :key="school.id"
                :clickable="true"
                :alt="school.name"
                @click="toggleTypeInfoWindow(school, 'elems')"
                :position="{ lat: school.latitude, lng: school.longitude }"
                :icon="'/images/icons/gmaps/marker-el.png'"
                :visible="school.showMapMarker"
              >
                <gmap-info-window
                  :position="{ lat: school.latitude, lng: school.longitude }"
                  :options="infoOptions"
                  :opened="school.showInfoWindow"
                  @closeclick="school.showInfoWindow = false"
                >
                  <h4>{{ school.name }} {{ school.end_name }}</h4>
                  <li
                    v-for="visualizerDatum in school.visualizer_data" v-bind:key="visualizerDatum"
                  >
                    {{ visualizerDatum }}
                  </li>
                </gmap-info-window>
                <gmap-polygon
                  :paths="school.polygons"
                  :editable="false"
                  :options="{
                    visible: school.showPolygons,
                    strokeColor: 'blue',
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: school.color,
                    fillOpacity: 0.35,
                  }"
                >
                </gmap-polygon>
              </gmap-marker>
            </div>
            <div
              v-if="this.jrHighs && !this.street.length && !this.zipcode.length"
            >
              <gmap-marker
                v-for="school in schools.junior_high"
                :key="school.id"
                :clickable="true"
                :alt="school.name"
                @click="toggleTypeInfoWindow(school, 'jh')"
                :position="{ lat: school.latitude, lng: school.longitude }"
                :icon="'/images/icons/gmaps/marker-jh.png'"
                :visible="school.showMapMarker"
              >
                <gmap-info-window
                  :position="{ lat: school.latitude, lng: school.longitude }"
                  :options="infoOptions"
                  :opened="school.showInfoWindow"
                  @closeclick="school.showInfoWindow = false"
                >
                  <h4>{{ school.name }} {{ school.end_name }}</h4>
                  <li
                    v-for="visualizerDatum in school.visualizer_data" v-bind:key="visualizerDatum"
                  >
                    {{ visualizerDatum }}
                  </li>
                </gmap-info-window>
                <gmap-polygon
                  :paths="school.polygons"
                  :editable="false"
                  :options="{
                    visible: school.showPolygons,
                    strokeColor: 'blue',
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: school.color,
                    fillOpacity: 0.35,
                  }"
                >
                </gmap-polygon>
              </gmap-marker>
            </div>
            <div
              v-if="
                this.highSchools && !this.street.length && !this.zipcode.length
              "
            >
              <gmap-marker
                v-for="school in schools.high_school"
                :key="school.id"
                :clickable="true"
                :alt="school.name"
                @click="toggleTypeInfoWindow(school, 'hs')"
                :position="{ lat: school.latitude, lng: school.longitude }"
                :icon="'/images/icons/gmaps/marker-hs.png'"
                :visible="school.showMapMarker"
              >
                <gmap-info-window
                  :position="{ lat: school.latitude, lng: school.longitude }"
                  :options="infoOptions"
                  :opened="school.showInfoWindow"
                  @closeclick="school.showInfoWindow = false"
                >
                  <h4>{{ school.name }} {{ school.end_name }}</h4>
                  <li
                    v-for="visualizerDatum in school.visualizer_data" v-bind:key="visualizerDatum"
                  >
                    {{ visualizerDatum }}
                  </li>
                </gmap-info-window>
                <gmap-polygon
                  :paths="school.polygons"
                  :editable="false"
                  :options="{
                    visible: school.showPolygons,
                    strokeColor: 'blue',
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: school.color,
                    fillOpacity: 0.35,
                  }"
                >
                </gmap-polygon>
              </gmap-marker>
            </div>
            <div
              v-if="this.choice && !this.street.length && !this.zipcode.length"
            >
              <gmap-marker
                v-for="school in schools.choice"
                :key="school.id"
                :clickable="true"
                :alt="school.name"
                @click="school.showInfoWindow = true"
                :position="{ lat: school.latitude, lng: school.longitude }"
                :icon="'/images/icons/gmaps/' + school.gmaps_marker"
                :visible="school.showMapMarker"
              >
                <gmap-info-window
                  :position="{ lat: school.latitude, lng: school.longitude }"
                  :options="infoOptions"
                  :opened="school.showInfoWindow"
                  @closeclick="school.showInfoWindow = false"
                >
                  <h4>{{ school.name }} {{ school.end_name }}</h4>
                  <li
                    v-for="visualizerDatum in school.visualizer_data" v-bind:key="visualizerDatum"
                  >
                    {{ visualizerDatum }}
                  </li>
                </gmap-info-window>
                <gmap-polygon
                  :paths="school.polygons"
                  :editable="false"
                  :options="{
                    visible: school.showPolygons,
                    strokeColor: 'blue',
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: school.color,
                    fillOpacity: 0.35,
                  }"
                >
                </gmap-polygon>
              </gmap-marker>
            </div>
            <div v-if="search.hasResults && search.isActive">
              <gmap-marker
                :position="{
                  lat: search.userGeocodeResults.lat,
                  lng: search.userGeocodeResults.lng,
                }"
                :clickable="true"
                @click="showUserInfoWindow = !showUserInfoWindow"
                :draggable="false"
                :icon="'/images/icons/gmaps/marker-home.png'"
              >
                <gmap-info-window
                  :position="{
                    lat: search.userGeocodeResults.lat,
                    lng: search.userGeocodeResults.lng,
                  }"
                  :options="infoOptions"
                  :opened="showUserInfoWindow"
                  @closeclick="showUserInfoWindow = false"
                >
                  <h4>{{ search.userGeocodeResults.address }}</h4>
                </gmap-info-window>
              </gmap-marker>
            </div>
          </gmap-map>
        </div>
        <!-- end map-container -->
      </div>
    </main>
  </body>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  name: "visualizer",
  components: {
    Header,
  },
    filters: {
        split: function (value) {
            return "value";
        }
    },
  data() {
    return {
      highSchools: window.location.pathname === "/hs" ? true : false,
      jrHighs: window.location.pathname === "/jh" ? true : false,
      elems: window.location.pathname === "/el" ? true : false,
      choice: false,
      street: "",
      zipcode: "",
      search: {
        hasResults: false,
        isActive: false,
        homeschools: [],
        userGeocodeResults: {
          address: "",
          lat: 0,
          lng: 0,
        },
      },
      showUserInfoWindow: false,
      mapCenter: { lat: 33.4304395, lng: -111.74174540000001 },
      zoom: 11,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: 0,
        },
      },
    };
  },
  computed: {
    categories() {
      return this.$store.state.search.categories;
    },
    schools() {
      return this.$store.getters.categorizedSchools;
    },
    ariaText() {
      const results = this.search.homeschools.map(
        (hs) => `${hs.name} ${hs.end_name}`
      );
      return `Home schools for ${
        this.search.userGeocodeResults.address
      } are: ${results.join(
        ", "
      )}. An interactive google map shows school locations. Below the map is more information on each school`;
    },
  },
  mounted() {
    document.getElementById("aria-label_locator").focus();
    switch (true) {
      case window.location.pathname === "/el":
        this.schools.elementary.map((school) =>
          this.togglePolygon(school, false)
        );
        this.schools.elementary.map((school) =>
          this.toggleMapMarker(school, false)
        );
        break;
      case window.location.pathname === "/jh":
        this.schools.junior_high.map((school) =>
          this.togglePolygon(school, false)
        );
        this.schools.junior_high.map((school) =>
          this.toggleMapMarker(school, false)
        );
        break;
      case window.location.pathname === "/hs":
        this.schools.high_school.map((school) =>
          this.togglePolygon(school, false)
        );
        this.schools.high_school.map((school) =>
          this.toggleMapMarker(school, false)
        );
        break;
      default:
        break;
    }
  },
  methods: {
    submit() {
      this.reset(false);
      this.$store
        .dispatch("getHomeschools", {
          address: this.street + ", " + this.zipcode,
        })
        .then((response) => {
          if (
            response.homeschools.length === 3 ||
            response.homeschools.length === 2
          ) {
            this.mapCenter = {
              lat: response.userData.latLng.lat(),
              lng: response.userData.latLng.lng(),
            };
            this.search = {
              hasResults: true,
              homeschools: response.homeschools,
              userGeocodeResults: {
                address: response.userData.address,
                lat: response.userData.latLng.lat(),
                lng: response.userData.latLng.lng(),
              },
            };
            this.search.homeschools.map((homeSchool) =>
              calculateDistance(
                this.search.userGeocodeResults.lat,
                this.search.userGeocodeResults.lng,
                homeSchool.latitude,
                homeSchool.longitude,
                "K",
                homeSchool
              )
            );
          }
          if (!response.homeschools.length) {
            this.street = "";
            this.zipcode = "";
          }
          this.search.isActive = true;
          this.$refs.searchHeader.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          gtag("event", "find_homeschools", {
            event_category: "locator_interaction",
            event_label: `${this.street} ${this.zipcode}`,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reset(clearInput) {
      this.search = {
        hasResults: false,
        isActive: false,
        homeschools: [],
        userGeocodeResults: {
          address: "",
          lat: 0,
          lng: 0,
        },
      };
      this.$store.commit("resetCompare");
      if (clearInput) {
        this.street = "";
        this.zipcode = "";
      }
      this.mapCenter = { lat: 33.4304395, lng: -111.74174540000001 };
      this.zoom = 11;
      this.closeAccordion();
    },
    toggleHomeSchoolPolygon(e, school) {
      if (e.target.tagName === "P") {
        school.showPolygons = !e.target.nextSibling.checked;
        e.target.nextSibling.checked = !e.target.nextSibling.checked;
      } else {
        school.showPolygons = e.target.checked;
      }
    },
    toggleHomeSchoolInfoWindow(school) {
      school.showInfoWindow = !school.showInfoWindow;
      this.search.homeschools
        .filter((s) => s.id !== school.id)
        .map((filteredSchool) => this.toggleInfoWindow(filteredSchool, true));
    },
    toggleTypeInfoWindow(school, type) {
      school.showInfoWindow = !school.showInfoWindow;
      switch (true) {
        case type === "elems":
          this.schools.elementary
            .filter((s) => s.id !== school.id)
            .map((filteredSchool) =>
              this.toggleInfoWindow(filteredSchool, true)
            );
          break;
        case type === "jh":
          this.schools.junior_high
            .filter((s) => s.id !== school.id)
            .map((filteredSchool) =>
              this.toggleInfoWindow(filteredSchool, true)
            );
          break;
        case type === "hs":
          this.schools.high_school
            .filter((s) => s.id !== school.id)
            .map((filteredSchool) =>
              this.toggleInfoWindow(filteredSchool, true)
            );
      }
    },
    togglePolygon(school, isVisible) {
      if (isVisible) {
        school.showPolygons = false;
      } else if (!isVisible) {
        school.showPolygons = true;
      }
    },
    toggleInfoWindow(school, isVisible) {
      // if (isVisible) {
      //   school.showInfoWindow = false;
      // } else if (!isVisible) {
      //   school.showInfoWindow = true;
      // }
    },
    toggleMapMarker(school, isVisible) {
      if (isVisible) {
        school.showMapMarker = false;
      } else if (!isVisible) {
        school.showMapMarker = true;
      }
    },
    closeAccordion() {
      this.schools.elementary.map((school) =>
        this.toggleInfoWindow(school, true)
      );
      this.schools.junior_high.map((school) =>
        this.toggleInfoWindow(school, true)
      );
      this.schools.high_school.map((school) =>
        this.toggleInfoWindow(school, true)
      );
      this.schools.choice.map((school) =>
        this.toggleInfoWindow(school, true)
      );
      this.schools.elementary.map((school) => this.togglePolygon(school, true));
      this.schools.junior_high.map((school) =>
        this.togglePolygon(school, true)
      );
      this.schools.high_school.map((school) =>
        this.togglePolygon(school, true)
      );
      this.schools.choice.map((school) =>
        this.togglePolygon(school, true)
      );
      this.schools.elementary.map((school) =>
        this.toggleMapMarker(school, true)
      );
      this.schools.junior_high.map((school) =>
        this.toggleMapMarker(school, true)
      );
      this.schools.high_school.map((school) =>
        this.toggleMapMarker(school, true)
      );
      this.schools.choice.map((school) =>
        this.toggleMapMarker(school, true)
      );
      this.elems = false;
      this.jrHighs = false;
      this.highSchools = false;
      this.choice = false;
    },
    toggleAccordion(type) {
      this.search.isActive = false;
      switch (true) {
        case type === "elems" && !this.elems:
          this.elems = true;
          this.jrHighs = false;
          this.highSchools = false;
          this.choice = false;
          this.schools.elementary.map((school) =>
            this.togglePolygon(school, false)
          );
          this.schools.junior_high.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.high_school.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.elementary.map((school) =>
            this.toggleMapMarker(school, false)
          );
          break;
        case type === "elems" && this.elems:
          this.elems = false;
          this.schools.elementary.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.elementary.map((school) =>
            this.toggleMapMarker(school, true)
          );
          break;
        case type === "jh" && !this.jrHighs:
          this.jrHighs = true;
          this.elems = false;
          this.highSchools = false;
          this.choice = false;
          this.schools.junior_high.map((school) =>
            this.togglePolygon(school, false)
          );
          this.schools.high_school.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.elementary.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.junior_high.map((school) =>
            this.toggleMapMarker(school, false)
          );
          break;
        case type === "jh" && this.jrHighs:
          this.jrHighs = false;
          this.schools.junior_high.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          break;
        case type === "hs" && !this.highSchools:
          this.highSchools = true;
          this.jrHighs = false;
          this.elems = false;
          this.choice = false;
          this.schools.high_school.map((school) =>
            this.togglePolygon(school, false)
          );
          this.schools.junior_high.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.elementary.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.high_school.map((school) =>
            this.toggleMapMarker(school, false)
          );
          break;
        case type === "hs" && this.highSchools:
          this.highSchools = false;
          this.schools.high_school.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          break;
        case type === "choice" && !this.choice:
          this.elems = false;
          this.jrHighs = false;
          this.highSchools = false;
          this.choice = true;
          this.schools.choice.map((school) =>
            this.togglePolygon(school, false)
          );
          this.schools.junior_high.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.high_school.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.choice.map((school) =>
            this.toggleMapMarker(school, false)
          );
          break;
        case type === "choice" && this.choice:
          this.choice = false;
          this.schools.choice.map((school) =>
            this.toggleInfoWindow(school, true)
          );
          this.schools.choice.map((school) =>
            this.toggleMapMarker(school, true)
          );
          break;
        default:
          break;
      }
      this.mapCenter = { lat: 33.4304395, lng: -111.74174540000001 };
      this.zoom = 11;
    },
    toggleZoomSchool(school, type) {
      school.showInfoWindow = !school.showInfoWindow;
      school.showMapMarker = true;
      this.mapCenter = { lat: school.latitude, lng: school.longitude };
      this.zoom = 11;
      switch (true) {
        case type === "elems":
          this.schools.elementary
            .filter((s) => s.id !== school.id)
            .map((s) => this.toggleInfoWindow(s, true));
          break;
        case type === "juniorHighs":
          this.schools.junior_high
            .filter((s) => s.id !== school.id)
            .map((s) => this.toggleInfoWindow(s, true));
          break;
        case type === "highSchools":
          this.schools.high_school
            .filter((s) => s.id !== school.id)
            .map((s) => this.toggleInfoWindow(s, true));
          break;
        case type === "choice":
          this.schools.choice
            .filter((s) => s.id !== school.id)
            .map((s) => this.toggleInfoWindow(s, true));
          break;
        default:
          break;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@keyframes Reveal {
  from {
    max-height: 0px;
  }
  to {
    max-height: 75px;
  }
}

@keyframes Conceal {
  from {
    max-height: 75px;
  }
  to {
    max-height: 0px;
  }
}

@keyframes FadeIn {
  25% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

@keyframes FadeOut {
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}

a,
p {
  word-wrap: break-word;
}

a:hover {
  color: darkred;
  text-decoration-line: underline;
  text-decoration-color: gold;
}

legend {
  text-decoration-line: underline;
}

.distance {
  font-weight: 400;
}

.inner-distance {
  font-weight: lighter;
}

#elemToggle,
#jhToggle,
#hsToggle {
  line-height: unset;
}

.input.bg-success:focus {
  border: 2px solid lawngreen;
}

.input.bg-danger:focus {
  border: 2px solid tomato;
}

.help-success {
  color: green;
}

.help-danger {
  color: red;
}

.button.is-danger {
  background: darkred;
  text-shadow: 0.5px 0.5px 0.5px black;
  font-weight: bolder;
}

.button.is-success {
  background: darkgreen;
  text-shadow: 0.5px 0.5px 0.5px black;
  font-weight: bolder;
}

.is-danger:hover {
  color: yellow;
  background: rgb(182, 1, 1);
}
.is-success:hover {
  color: yellow;
  background: rgb(1, 141, 1);
}
fieldset {
  border: none;
}

.marker-wrapper {
  animation: FadeIn 5s both;
}
.ul-body {
  max-height: 350px;
  overflow: scroll;
  overflow-x: hidden;
  background: white;
  animation: Reveal 0.5s, FadeIn 0.5s;
  text-shadow: 0.5px 0.5px 0.5px black;
}
.ul-hide {
  max-height: 0px;
  overflow: scroll;
  overflow-x: hidden;
  background: rgba(29, 28, 28, 0.445);
  animation: Conceal 0.5s, FadeOut 0.5s;
}
.ul-title {
  position: sticky;
  margin-top: 3px;
  margin-bottom: 3px;
  background: #126;
  color: whitesmoke;
  padding: 7px 7px 7px 7px;
  cursor: pointer;
  border: 1px solid transparent;
  font-weight: bold;
  text-shadow: 1px 1px 1px black;
}
.ul-title:hover {
  background: rgb(86, 98, 150);
  border: 1px solid transparent;
  color: yellow;
}
.locator-title {
  margin-left: 25px;
}
.locator-subtitle {
  margin-left: 25px;
  padding-bottom: 10px;
  font-size: small;
}
.search-container {
  background-color: beige;
  width: 100%;
  // box-shadow: 0px 6px 10px #999;
  @media screen and (min-width: 1024px) {
    width: 375px;
  }
  @media screen and (min-width: 1216px) {
    width: 450px;
  }
}
.map-container {
  height: 500px;
  width: 100%;
  // box-shadow: 0px 6px 10px #999;
  @media screen and (min-width: 1024px) {
    min-height: 500px;
    height: auto;
    width: calc(100% - 375px);
  }
  @media screen and (min-width: 1216px) {
    width: calc(100% - 450px);
  }
}

.cards-container {
  width: 300px;
  padding: 0.75rem 0;
  margin-left: auto;
  margin-right: auto;
  -webkit-overflow-scrolling: touch;
  @media screen and (min-width: 400px) {
    //when 1 card(360px width + 24px margins) will fit on screen
    width: 384px;
  }
  @media screen and (min-width: 768px) {
    //when 2 cards(360px width + 24px margins) will fit on screen
    width: 768px;
  }
  @media screen and (min-width: 1024px) {
    //when 3 cards(315px width + 20px margins) will fit on screen
    width: 960px;
  }
  @media screen and (min-width: 1216px) {
    //when 3 cards(360px width + 24px margins) will fit on screen
    width: 1152px;
  }
}
</style>
